import type { ReactElement } from 'react'

import type { NotificationFormType } from '@/notificationForms'
import type { NotificationFormValues } from '../NotificationForm'

import { preview } from '@/components/form/preview'
import { useConfirmNotificationToggleModal } from '@/components/modals/ConfirmNotificationToggleModal'
import { useTestEmailNotificationModal } from '@/components/modals/TestEmailNotificationModal'
import { useTestPhoneNotificationModal } from '@/components/modals/TestPhoneNotificationModal'
import { Header } from './components/Header'

type Props = {
  values: Partial<NotificationFormValues>
  notification: NotificationFormType
  toggleSubtitle: string
  available?: boolean
  onToggle: () => void
  onEdit: () => void
  Form: ReactElement
  subtitle: string
  title: string
}

export function NotificationView(props: Props) {
  const {
    available = true,
    toggleSubtitle,
    notification,
    onToggle,
    subtitle,
    values,
    onEdit,
    title,
    Form,
  } = props

  const { Modal: PhoneModal, show: showPhoneTestNotificationModal } =
    useTestPhoneNotificationModal()

  const { Modal: EmailModal, show: showEmailTestNotificationModal } =
    useTestEmailNotificationModal()

  const { Modal: ConfirmNotificationToggleModal, show: showConfirmModal } =
    useConfirmNotificationToggleModal()

  const onTest =
    values.notificationWay === 'PHONE'
      ? showPhoneTestNotificationModal
      : showEmailTestNotificationModal

  const Modal = values.notificationWay === 'PHONE' ? PhoneModal : EmailModal

  const enabled = available ? !!values.enabled : false

  return (
    <preview.Root
      applyPendingFitMapOnMount={false}
      rightBorder={false}
      header={
        <Header
          notification={notification}
          available={available}
          subtitle={subtitle}
          title={title}
          onEdit={onEdit}
          onTest={onTest}
          onToggle={showConfirmModal}
          enabled={enabled}
        />
      }
    >
      {Form}

      <Modal notification={notification} values={values} />

      <ConfirmNotificationToggleModal
        goingToEnable={!values.enabled}
        notification={notification}
        subtitle={toggleSubtitle}
        onToggle={onToggle}
        title={title}
      />
    </preview.Root>
  )
}
